import { Component, contentChild, Signal } from '@angular/core';
import { DetailedLoadingIndicatorComponent } from '../detailed-loading-indicator/detailed-loading-indicator.component';
import { LoadingIndicatorComponent } from './loading-indicator.component';

@Component({
  selector: 'td-wb-loading-indicator-panel',
  templateUrl: 'loading-indicator-panel.component.html',
  styleUrls: ['loading-indicator-panel.component.scss'],
  imports: [DetailedLoadingIndicatorComponent]
})
export class LoadingIndicatorPanelComponent {
  readonly customLoadingIndicator: Signal<LoadingIndicatorComponent | undefined> = contentChild(LoadingIndicatorComponent);
}
